import React, { useState, useEffect } from "react";
import CalendarSVG from "../assets/precheckin/calendar.svg";
import { customCalendarClassNames } from "./styles/AvailabilityStyle";
import { Modal } from "react-responsive-modal";
import moment from "moment";
import HorScroll from "./HorScroll";
import { withTranslation, useTranslation } from "react-i18next";
import LoadingIcon from "./LoadingIcon";

const Availability = (props) => {
  const [loading, setLoading] = useState(false);
  const [availabilityOpen, setAvailabilityOpen] = useState(
    props.showPopup || false
  );
  const [availabilities, setAvailabilities] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    if (props.getAvailabilities) setAvailabilities(props.getAvailabilities);
  }, [props.getAvailabilities]);

  const onCloseAvailabilityModal = () => {
    props.onCancel();
    const html = document.querySelector("html");
    html.style = "";
  };

  const selectBtn = (e, inventory) => {
    setAvailabilityOpen(!availabilityOpen);
    props.onSelect({
      e,
      inventory,
      date: props.getDate,
    });
  };
  const selectedDate = props.getDate ? moment(props.getDate) : moment();

  let prefix = "";
  let weekFormat = "ddd";
  if (moment().diff(selectedDate, "days") === 0) {
    prefix = "Today";
    weekFormat = "";
  } else if (moment().diff(selectedDate, "days") === 1) {
    prefix = "Tomorrow";
    weekFormat = "";
  }
  const selectedDateWFormat = `${prefix}${selectedDate.format(
    props.format || `${weekFormat}, MMM DD`
  )}`;
  const selectedDateWFormat2 = `${prefix}${selectedDate.format(
    props.format || `${weekFormat}, MMMM DD`
  )}`;

  const rangeOfDates = () => {
    let range = [];
    if (props.dates && props.dates.length > 0) {
      props.dates.map((date) =>
        range.push({
          id: date.format("YYYYMMDD"),
          week: date.format("ddd"),
          value: date.format("MM/DD"),
        })
      );
    } else {
      const fromDate = moment(props.fromDate || moment().format("YYYY-MM-DD"));
      const toDate = moment(props.toDate || moment().format("YYYY-MM-DD"));
      let diff = toDate.diff(fromDate, "days");
      diff = diff ? diff : 0;
      for (let i = 0; i <= diff; i++) {
        let fromDateClone = fromDate.clone();
        fromDateClone = fromDateClone.add(i, "day");
        range.push({
          id: fromDateClone.format("YYYYMMDD"),
          week: fromDateClone.format("ddd"),
          value: fromDateClone.format("MM/DD"),
        });
      }
    }
    return range;
  };

  const fetchData = async (date) => {
    setLoading(true);
    await props.onFetchAvailabilities({
      date: date,
      timeframe: props.getTimeframe,
    });
    setLoading(false);
  };

  const addDaysToDate = (date, day = 0) => {
    let dateClone = date.clone();
    return dateClone.add(day, "day");
  };

  const pnProductNav = document.getElementById("pnProductNav");
  const pnProductNavContents = document.getElementById("pnProductNavContents");

  const goToNextDays = (date, autoScroll = false) => {
    const dates = rangeOfDates();
    const nextIndex = dates.findIndex((item) => date === item.id);
    if (autoScroll) {
      fetchData(date);
      if (pnProductNavContents.children[nextIndex]) {
        const scrollLeft =
          pnProductNavContents.children[nextIndex].offsetLeft - 10;
        pnProductNav.scrollTo({
          left: scrollLeft,
          behavior: "smooth",
        });
      }
    } else return !!pnProductNavContents.children[nextIndex];
  };

  return (
    <div className="h-full">
      <Modal
        open={availabilityOpen}
        onClose={onCloseAvailabilityModal}
        center
        blockScroll={true}
        classNames={customCalendarClassNames}>
        <div className="relative h-full flex flex-col">
          <div
            style={{ backgroundColor: "#EAEAEA" }}
            className="mb-6">
            <div className="flex mx-auto max-w-xl py-4">
              <h3 className="text-14 px-4 py-3">{props.modalTitle}</h3>
            </div>
          </div>
          <div className="mb-4 flex-1">
            <div className="flex flex-col">
              <p className="text-16 text-center mb-6">{props.t("EVENTS")}</p>
              <p className="text-18 text-center mb-6">{props.eventName}</p>
            </div>
            <div
              onClick={(e) => props.onback(e)}
              className={`mx-auto max-w-lg border rounded-full py-4 w-full px-4 outline-none focus:outline-none mb-6 flex justify-center cursor-pointer ${props.className}`}
              style={{ borderColor: "#DBDBDB" }}>
              <p
                className={`flex items-center mr-4 ${
                  props.className && props.className
                }`}>
                <img
                  src={CalendarSVG}
                  alt="calendar"
                  className="w-8 h-8 mr-4"
                />
                {selectedDateWFormat}
              </p>
              <p className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8 mr-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                {props.getTime || "00:00 - 24:00"}
              </p>
            </div>
            <div className="mx-auto max-w-xl py-4">
              <HorScroll>
                {rangeOfDates().map((item, index) => (
                  <button
                    key={index}
                    onClick={(e) => goToNextDays(item.id, true)}
                    className="px-2 mx-2 inline-flex uppercase leading-6 preCheckinButton font-normal text-12 text-center py-3 rounded-lg"
                    style={{
                      color:
                        selectedDate.format("YYYYMMDD") === item.id
                          ? "#ffff"
                          : "#C6C6C6",
                      backgroundColor:
                        selectedDate.format("YYYYMMDD") === item.id
                          ? props.primaryColor
                          : "",
                    }}>
                    {item.week}
                    <br />
                    {item.value}
                  </button>
                ))}
              </HorScroll>
            </div>
            {availabilities.length > 0 && (
              <div style={{ backgroundColor: "#EAEAEA" }}>
                <div className="mx-auto max-w-xl py-4 flex">
                  <p className="text-14 pr-16 py-3">{props.t("START")}</p>&nbsp;
                  <p className="text-14 px-16 py-3">{props.t("END")}</p>
                  <p>&nbsp;</p>
                </div>
              </div>
            )}
            <div
              className="mx-auto max-w-xl overflow-y-auto"
              style={{ height: "calc( 100vh - 305px )" }}>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                  <LoadingIcon loadingState={true} />
                </div>
              ) : (
                <>
                  {availabilities.map((item, index) => (
                    <div
                      className="w-full my-4 "
                      key={index}>
                      <div className="flex justify-between">
                        <div className="flex align-middle flex-1">
                          <p className="text-14 pr-12 py-4">
                            {item.start_time}
                          </p>
                          <p className="text-14 px-2 py-4">-</p>
                          <p className="text-14 px-12 pr-4 py-4">
                            {item.end_time}
                          </p>
                        </div>
                        <button
                          className={`app-outline-button type-title medium ${props.buttonStyleName}`}
                          style={{
                            backgroundColor: props.primaryColor,
                            color: props.appHomeTextCallToAction || "#ffffff",
                          }}
                          onClick={(e) => selectBtn(e, item)}>
                          {props.t("SELECT")}
                        </button>
                      </div>
                    </div>
                  ))}
                  {availabilities.length === 0 && (
                    <div className="w-full my-4">
                      <p className="text-center text-14 mb-4">
                        {props.t("NO_APPOINTMENTS_AVAILABLE")}
                      </p>
                      <p className="text-center text-14 mb-4">
                        {selectedDateWFormat2}
                      </p>
                      <div className="text-center">
                        <button
                          className={`app-outline-button type-title medium ${props.buttonStyleName}`}
                          style={{
                            backgroundColor: props.primaryColor,
                            color: props.appHomeTextCallToAction || "#ffffff",
                          }}
                          onClick={(e) => props.onback(e)}>
                          {t("GO_BACK")}
                        </button>
                        {pnProductNav &&
                          pnProductNavContents &&
                          goToNextDays(
                            addDaysToDate(selectedDate, 2).format("YYYYMMDD"),
                            false
                          ) && (
                            <>
                              <div className="row text-center relative mt-4 mb-2">
                                <div
                                  className="absolute"
                                  style={{
                                    left: "0",
                                    right: "0",
                                    top: "16px",
                                    padding: "1px",
                                    background: "rgb(219 219 219)",
                                  }}></div>
                                <h2
                                  className="text-14 relative z-20"
                                  style={{
                                    background: "#fff",
                                    display: "inline-block",
                                    padding: "10px 20px",
                                  }}>
                                  {props.t("OR")}
                                </h2>
                                <p className="text-14 text-center mb-4">
                                  {props.t("SEE_APPOINTMENTS_ON")}
                                </p>
                              </div>
                              <div className="text-center mb-4">
                                <button
                                  className={`app-outline-button type-title medium ${props.buttonStyleName}`}
                                  style={{
                                    backgroundColor: props.primaryColor,
                                    color:
                                      props.appHomeTextCallToAction ||
                                      "#ffffff",
                                  }}
                                  onClick={(e) =>
                                    goToNextDays(
                                      addDaysToDate(selectedDate, 2).format(
                                        "YYYYMMDD"
                                      ),
                                      true
                                    )
                                  }>
                                  {`${addDaysToDate(selectedDate, 2).format(
                                    props.format || "dddd, MMMM DD"
                                  )} (2 ${props.t("DAYS_LATER")})`}
                                </button>
                              </div>
                              {goToNextDays(
                                addDaysToDate(selectedDate, 7).format(
                                  "YYYYMMDD"
                                ),
                                false
                              ) && (
                                <div className="text-center mb-4">
                                  <button
                                    className={`app-outline-button type-title medium ${props.buttonStyleName}`}
                                    style={{
                                      backgroundColor: props.primaryColor,
                                      color:
                                        props.appHomeTextCallToAction ||
                                        "#ffffff",
                                    }}
                                    onClick={(e) =>
                                      goToNextDays(
                                        addDaysToDate(selectedDate, 7).format(
                                          "YYYYMMDD"
                                        ),
                                        true
                                      )
                                    }>
                                    {`${addDaysToDate(selectedDate, 7).format(
                                      props.format || "dddd, MMMM DD"
                                    )} (1 ${props.t("WEEK_LATER")})`}
                                  </button>
                                </div>
                              )}
                            </>
                          )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default withTranslation()(Availability);
